export const MailOutlinedSVG = (props) => (
  <svg height="23" viewBox="0 0 31 23" width="31" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#030203"
      strokeLinecap="round"
      strokeWidth="1.2"
      transform="translate(1.091198 1.214985)"
    >
      <path d="m.00046643 20.8727088h28.83411187v-20.87261149h-28.83411187z"/>
      <path d="m0 0 14.4164476 10.4565458 14.4176643-10.4565458"/>
    </g>
  </svg>
);
